export const Estimate = {
  data() {
    return {
      services: [
        { name: "Concrete Driveway", baseRate: 0.35, surfaceType: "concrete" },
        { name: "Brick Paver Driveway", baseRate: 0.45, surfaceType: "pavers" },
        {
          name: "Pool Deck - Concrete",
          baseRate: 0.4,
          surfaceType: "concrete"
        },
        { name: "Pool Deck - Pavers", baseRate: 0.5, surfaceType: "pavers" },
        {
          name: "Lanai/Screen Enclosure",
          baseRate: 0.6,
          surfaceType: "screen"
        },
        {
          name: "House Exterior - Single Story",
          baseRate: 0.55,
          surfaceType: "siding"
        },
        {
          name: "House Exterior - Two Story",
          baseRate: 0.65,
          surfaceType: "siding"
        },
        { name: "Tile Roof Cleaning", baseRate: 0.75, surfaceType: "roof" },
        { name: "Shingle Roof Cleaning", baseRate: 0.85, surfaceType: "roof" },
        { name: "Wooden Deck/Dock", baseRate: 0.6, surfaceType: "wood" },
        {
          name: "Patio/Walkway - Concrete",
          baseRate: 0.4,
          surfaceType: "concrete"
        },
        {
          name: "Patio/Walkway - Pavers",
          baseRate: 0.5,
          surfaceType: "pavers"
        },
        { name: "Fence Cleaning", baseRate: 0.45, surfaceType: "fence" }
      ],
      conditions: [
        { name: "Light Dirt/Algae", multiplier: 1.0 },
        { name: "Moderate Dirt/Staining", multiplier: 1.2 },
        { name: "Heavy Mold/Mildew", multiplier: 1.4 },
        { name: "Severe Buildup/Staining", multiplier: 1.6 }
      ],
      additionalServices: [
        { name: "Mold Treatment & Prevention", price: 150 },
        {
          name: "Paver Sealing",
          price: 0.75,
          type: "sqft",
          surfaceType: "pavers"
        },
        { name: "Rust Removal", price: 75 },
        { name: "Gutter Cleaning", price: 100 },
        { name: "Window Cleaning", price: 8, type: "window" },
        { name: "Deck Sealing", price: 0.85, type: "sqft", surfaceType: "wood" }
      ],
      urgencyOptions: [
        { name: "Standard (1-2 weeks)", multiplier: 1.0 },
        { name: "Priority (3-5 days)", multiplier: 1.2 },
        { name: "Urgent (24-48 hours)", multiplier: 1.5 }
      ],
      selectedService: null,
      squareFootage: 0,
      condition: 1.0,
      selectedServices: [],
      urgencyMultiplier: 1.0
    };
  },
  computed: {
    isFormValid() {
      return (
        this.selectedService &&
        this.squareFootage > 0 &&
        this.condition &&
        this.urgencyMultiplier
      );
    },
    availableAdditionalServices() {
      if (!this.selectedService) return this.additionalServices;
      return this.additionalServices.filter(
        (service) =>
          !service.surfaceType ||
          service.surfaceType === this.selectedService.surfaceType
      );
    },
    basePrice() {
      return this.squareFootage * (this.selectedService?.baseRate || 0);
    },
    conditionAdjustment() {
      return this.basePrice * (this.condition - 1);
    },
    additionalServicesTotal() {
      return this.selectedServices.reduce((total, service) => {
        if (service.type === "sqft") {
          return total + service.price * this.squareFootage;
        }
        return total + service.price;
      }, 0);
    },
    urgencyPremium() {
      return this.basePrice * (this.urgencyMultiplier - 1);
    },
    totalEstimate() {
      return (
        this.basePrice +
        this.conditionAdjustment +
        this.additionalServicesTotal +
        this.urgencyPremium
      );
    }
  },
  methods: {
    formatServicePrice(service) {
      if (service.type === "sqft") {
        return `+$${service.price}/sq ft`;
      }
      return `+$${service.price}`;
    },
    saveEstimate() {
      const estimateData = {
        serviceType: this.selectedService?.name,
        squareFootage: this.squareFootage,
        condition: this.condition,
        additionalServices: this.selectedServices.map((s) => s.name),
        urgency: this.urgencyMultiplier,
        basePrice: this.basePrice,
        conditionAdjustment: this.conditionAdjustment,
        additionalServicesTotal: this.additionalServicesTotal,
        urgencyPremium: this.urgencyPremium,
        totalEstimate: this.totalEstimate,
        timestamp: new Date().toISOString()
      };

      this.$router.push({
        name: "home",
        query: {
          estimateData: JSON.stringify(estimateData)
        }
      });
    },
    resetForm() {
      this.selectedService = null;
      this.squareFootage = 0;
      this.condition = 1.0;
      this.selectedServices = [];
      this.urgencyMultiplier = 1.0;
    }
  },

  template: "#estimate"
};
